import { useMemo, useState } from "react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList } from "@/components/ui/command";
import { Button } from "@/components/ui/button";
import { Check, ChevronsUpDown, Globe } from "lucide-react";

const getTimezones = () => {
  try {
    return Intl.supportedValuesOf("timeZone");
  } catch (e) {
    return ["UTC", "America/New_York", "America/Chicago", "America/Los_Angeles", "Europe/London", "Europe/Paris", "Asia/Dubai", "Asia/Kolkata", "Asia/Singapore", "Australia/Sydney"];
  }
};

export const TimezoneCombobox = ({ value, onChange, disabled = false }) => {
  const [open, setOpen] = useState(false);
  const timezones = useMemo(getTimezones, []);
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button variant="outline" role="combobox" disabled={disabled}
          className="w-full justify-between rounded-lg font-normal" data-testid="timezone-combobox-trigger">
          <span className="flex items-center gap-2 truncate">
            <Globe className="h-4 w-4 text-muted-foreground shrink-0" />
            {value || "Select timezone"}
          </span>
          <ChevronsUpDown className="h-4 w-4 text-muted-foreground shrink-0" />
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-[320px] p-0" align="start">
        <Command>
          <CommandInput placeholder="Search timezones…" data-testid="timezone-search-input" />
          <CommandList>
            <CommandEmpty>No timezone found.</CommandEmpty>
            <CommandGroup>
              {timezones.map((tz) => (
                <CommandItem key={tz} value={tz} onSelect={() => { onChange(tz); setOpen(false); }}>
                  <Check className={`mr-2 h-4 w-4 ${tz === value ? "opacity-100" : "opacity-0"}`} />
                  {tz}
                </CommandItem>
              ))}
            </CommandGroup>
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
};
